import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type { GetRevenueParams, RevenueSummaryResponse } from 'api/executive/executive.types'

export function useRevenueSummary() {
  return useExecutiveQuery<GetRevenueParams, RevenueSummaryResponse>(
    'performance.revenue-summary',
    PerformanceApi.getRevenueSummary,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
        granularity: 'total',
        compareWithPrevious: true,
      }
    }
  )
}
